import React from 'react';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';

/**
 * Just a helper for frequent use of nested Row/Col
 */
export default class RowCol extends React.Component<React.PropsWithChildren> {
  render(): React.ReactNode {
    return (
      <Row>
        <Col>{this.props.children}</Col>
      </Row>
    );
  }
}
